/**
 * Manage iframe post messaging
 */
// Import the popUpMainWindow action.
import {
  updateOpenUHMThroughLink,
  updateSettingsSiteData,
  updateHeaderReloadAndBack,
  updateContextualLinkOrigin,
  updateLinkLocation,
  updateHeaderAndFabColor,
  updateDeepLinkCAEduFlow,
  updateHideSecondaryNav,
  updateMeMenuAvailable,
  updateSessionTokenAvailable,
  updateMeMenuLoading,
  updateProfile
} from '../actions';
// Import the redux store
import {store} from '../configureStore';
//import the fetchLinkToMapping function
import {fetchLinkToMapping} from './utilFunctions';
import {forgeRemoveUserDetailsFromSessionStorage} from './utilForge';
import {v1 as uuidv1} from 'uuid';
import {adpAnalyticsLog, buildAdpAnalyticsPayload} from './utilADPAnalytics';

// Deal with post messages
// removed as no longer needed
// readd if a listener is needed
/* const receiveMessage = event => {}; */

// intialize the iframe if it exists
// call check immediate function
const initUhmFrameListeners = () => {
  if (window.self !== window.top) {
    const el = document.querySelector('#uhm-root');
    el.classList.add('is-in-iframe');
    window.addEventListener('message', receiveMessage, false);
  }
};

const receiveMessage = (event) => {
  if (event.data && event.data.type) {
    if (event.data.type === 'SHOW_CONTAINER') {
      const el = document.querySelector('.flyout__wrapper');
      el.classList.remove('flyout--hidden');
    } else if (event.data.type === 'SHOW_TRIGGER') {
      const el = document.querySelector('.uh-fab');
      el?.classList?.remove('uh-fab--hidden');
    } else if (event.data.type === 'REDIRECT_HOME') {
      const breadCrumbStart = document.querySelector(
        '.breadcrumb-item[data-value="start"]'
      );
      breadCrumbStart &&
        breadCrumbStart.innerText !== '' &&
        breadCrumbStart.click();
    } else if(event.data.type === 'WINDOW_DIGITALDATA') {
      window['digitalData'] = JSON.parse(event.data.data);
    } else if(event.data.type === 'cp.s_ecid') {
      window.utag = window.utag || {};
      window.utag.data = window.digitalData.data || {};
      window.utag.data['cp.s_ecid'] = event.data.data;
    } else if (event.data.type === 'UPDATE_UHM_OPTIONS') {
      const {
        deepLinkToValue,
        contextualLinkOrigin,
        updateColor,
        linkLocation = '',
        //for In-product Help
        release,
        viewedArticles,
        viewingArticle,
        pageTitle,
        iphSearchTerm,
        showContextualPopUp
      } = event.data.options;

      // Call the fetchLinkToMapping function here to update the siteData in the store
      let getStore = store.getState();

      if (getStore.uiOptions && updateColor) {
        //update the store with the passed header color
        store.dispatch(updateHeaderAndFabColor(updateColor));
      }

      if (release || viewedArticles || viewingArticle || iphSearchTerm || showContextualPopUp !== null) {
        let settingsToOverride = {
          ...release && {release},
          //...viewedArticles && {viewedArticles},
          ...viewingArticle && {viewingArticle},
          showContextualPopUp
        }

        let tmpUpdateSiteData = {
          ...getStore.appSettings,
          ...settingsToOverride
        }
        if (viewingArticle) {
          let tmpViewedArticle = {
            title: pageTitle,
            caasKey: viewingArticle,
            // TODO: harded coded path prefix, replace with variables from store for ACD, 2023 and map to beehive code for ENU
            contentUrl: `https://help.autodesk.com/view/ACD/2023/ENU/?caas=${viewingArticle}`,
            sourceLabel: ''
          }

          let mergedArticles = [...getStore.appSettings.viewedArticles,tmpViewedArticle];
          // TODO: disabling de-duplication for now. It's changing the array order.
          // As an ehancement look at adding timestamp and using that to sort after de-duplication
          // let key = 'caasKey';
          // let uniqueArticles = [...new Map(mergedArticles.map(item =>[item[key], item])).values()]
          // let limitedUniqueArticles = uniqueArticles.slice(-4);
          let limitedArticles = mergedArticles.slice(-8);
          tmpUpdateSiteData = {...tmpUpdateSiteData, viewedArticles: limitedArticles, pageTitle: pageTitle}
        }

        // update IPH search tems to agent
        if (iphSearchTerm) {
          let tmpIphSearchTerms = getStore?.appSettings?.iphSearchTerms || []
          // do not add duplicate searches
          if (!tmpIphSearchTerms.includes(iphSearchTerm)) {
            tmpIphSearchTerms.push(iphSearchTerm);
          }
          tmpUpdateSiteData = {...tmpUpdateSiteData, iphSearchTerms: tmpIphSearchTerms.slice(-5)}
        }

        store.dispatch(
          updateSettingsSiteData(tmpUpdateSiteData)
        );
      }

      if (
        getStore.uiOptions.openUHMThroughLink &&
        getStore.uiOptions.showMainWindow
      ) {
        return;
      } else {
        if (
          getStore.uiOptions &&
          !getStore.uiOptions.openUHMThroughLink &&
          deepLinkToValue
        ) {
          // update the contextual link flag to true
          store.dispatch(updateOpenUHMThroughLink(true));
          // update the showHeaderAndReload sub-header to true
          store.dispatch(updateHeaderReloadAndBack(true));
          // update whether the link origin
          store.dispatch(updateContextualLinkOrigin(contextualLinkOrigin));
          // update the CTA link location.
          store.dispatch(updateLinkLocation(linkLocation));
          // set the DeepLinkCAEduFlow state to false
          store.dispatch(updateDeepLinkCAEduFlow(false));
          // reset the hideSecondaryNav to false
          store.dispatch(updateHideSecondaryNav(false));
        }
      }

      // DeepLinking solution
      if (deepLinkToValue) {
        fetchLinkToMapping(deepLinkToValue).then((res) => {
          let settingsOverrides = {};
          if (deepLinkToValue === 'AVA-sales-chat') {
            const newFlowId = uuidv1();
            settingsOverrides = {
              utmSourceOverride: 'dotcom-sales_chatbot',
              flowId: newFlowId,
              subOrigin: 'UHM Sales Bot',
            };
            adpAnalyticsLog(
              buildAdpAnalyticsPayload({
                e: 'sales_chatbot_click',
                ev: getStore.appSettings.pageTitle,
                cm_flow_id: newFlowId,
                cm_origin_app: 'dotcom-sales_chatbot',
                cm_current_app: 'dotcom-sales_chatbot',
                cm_link_location: linkLocation,
              })
            );
          }

          store.dispatch(
            updateSettingsSiteData({
              ...getStore.appSettings,
              linkTo: res,
              ...settingsOverrides,
            })
          );
        });
      }
    } else if (event.data.type === 'ME_MENU_AVAILABLE') {
      store.dispatch(
        updateMeMenuAvailable(true)
      );
    } else if (event.data.type === 'SESSION_TOKEN_AVAILABLE') {
      let getStore = store.getState();
      const {sessionTokenAvailable: previousToken } = getStore.appSettings;
      if(previousToken && previousToken !== event.data.data){
        //The user switch happens or token refreshed. Clear the user details and entitlements from redux store.
        forgeRemoveUserDetailsFromSessionStorage();
      }
      store.dispatch(
        updateSessionTokenAvailable(event.data.data)
      );
      setTimeout(() => {
        store.dispatch(
          updateMeMenuLoading(false)
        );
      }, 1000);
    } else if (event.data.type === 'SESSION_TOKEN_NOT_AVAILABLE') {
      store.dispatch(
        updateSessionTokenAvailable('')
      );
    } else if (event.data.type === 'PROFILE_FROM_PARENT') {
      store.dispatch(
        updateProfile(event.data.data)
      );
    } else if (event.data.type === 'ME_MENU_LOADING') {
      //Added a delay before not showing the loading spinner
      setTimeout(() => {
        store.dispatch(
          updateMeMenuLoading(event.data.data)
        );
      }, 1000);
    }
  }
};

export {initUhmFrameListeners};
